<script setup lang="ts">
import { getComponentType, getLinkProps } from '#components/elements/card/card.utils';
import { computed } from 'vue';
import VueFeather from 'vue-feather';
import { type RouteLocationRaw } from 'vue-router';

const {
  to,
  label,
  disabled = false
} = defineProps<{
  to: RouteLocationRaw;
  label: string;
  disabled?: boolean;
}>();

const component = getComponentType(to);
const linkProps = getLinkProps(to);

const classes = computed(() => ({
  'opacity-40 pointer-events-none': disabled
}));
</script>

<template>
  <Component
    :is="component"
    v-bind="linkProps"
    class="flex flex-row items-center justify-center w-full h-full rounded-sm text-primary border-primary border hover:shadow-main cursor-pointer duration-100 ease active:translate-y-1 active:shadow-none py-4 px-2"
    :class="classes"
    :disabled="disabled"
  >
    <div>{{ label }}</div>
    <VueFeather is="div" type="arrow-right" class="text-primary bg-white p-2 rounded-bl" aria-hidden="true" />
  </Component>
</template>
